  import React, { useState } from "react";
  import { Link } from "react-router-dom";
  import "./styles/Header.css";

  export default function Header() {
    const [menuOpen, setMenuOpen] = useState(false);

    const toggleMenu = () => {
      setMenuOpen(!menuOpen);
    };

    return (
      <header className="header">
        <div className="logo">
          <Link to="/">Siara Marketing PVT LTD</Link>
        </div>

        <nav className={`nav ${menuOpen ? "open" : ""}`}>
          <Link to="/services" onClick={() => setMenuOpen(false)}>Services</Link>
          <Link to="/about" onClick={() => setMenuOpen(false)}>About</Link>
          <Link to="/contact" onClick={() => setMenuOpen(false)}>Contact</Link>
        </nav>

        <div className={`burger ${menuOpen ? "toggle" : ""}`} onClick={toggleMenu}>
          <div className="line1"></div>
          <div className="line2"></div>
          <div className="line3"></div>
        </div>
      </header>
    );
  }
